import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.nvaTeal,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default accordion;